export default {
  computed: {
    availableSizes() {
      return {
        COL_SIZE_1_1: {
          columns: [{
            containerClasses: {
              desktop: [{ property: 'ColumnWidth', value: 'WIDTH_12_12', touched: false }],
              tablet: [{ property: 'ColumnWidth', value: 'WIDTH_12_12', touched: false }],
              phone: [{ property: 'ColumnWidth', value: 'WIDTH_12_12', touched: false }],
            }
          }]
        },
        COL_SIZE_1_2: {
          columns: [{
              containerClasses: {
                phone: [{ property: 'ColumnWidth', value: 'WIDTH_12_12', touched: false }],
                tablet: [{ property: 'ColumnWidth', value: 'WIDTH_6_12', touched: false }],
                desktop: [{ property: 'ColumnWidth', value: 'WIDTH_6_12', touched: false }],
              }
            },
            {
              containerClasses: {
                phone: [{ property: 'ColumnWidth', value: 'WIDTH_12_12', touched: false }],
                tablet: [{ property: 'ColumnWidth', value: 'WIDTH_6_12', touched: false }],
                desktop: [{ property: 'ColumnWidth', value: 'WIDTH_6_12', touched: false }],
              }
            }
          ]
        },
        COL_SIZE_1_3: {
          columns: [{
              containerClasses: {
                phone: [{ property: 'ColumnWidth', value: 'WIDTH_12_12', touched: false }],
                tablet: [{ property: 'ColumnWidth', value: 'WIDTH_4_12', touched: false }],
                desktop: [{ property: 'ColumnWidth', value: 'WIDTH_4_12', touched: false }],
              }
            },
            {
              containerClasses: {
                phone: [{ property: 'ColumnWidth', value: 'WIDTH_12_12', touched: false }],
                tablet: [{ property: 'ColumnWidth', value: 'WIDTH_4_12', touched: false }],
                desktop: [{ property: 'ColumnWidth', value: 'WIDTH_4_12', touched: false }],
              }
            },
            {
              containerClasses: {
                phone: [{ property: 'ColumnWidth', value: 'WIDTH_12_12', touched: false }],
                tablet: [{ property: 'ColumnWidth', value: 'WIDTH_4_12', touched: false }],
                desktop: [{ property: 'ColumnWidth', value: 'WIDTH_4_12', touched: false }],
              }
            },
          ]
        },
        COL_SIZE_1_4: {
          columns: [{
              containerClasses: {
                phone: [{ property: 'ColumnWidth', value: 'WIDTH_12_12', touched: false }],
                tablet: [{ property: 'ColumnWidth', value: 'WIDTH_3_12', touched: false }],
                desktop: [{ property: 'ColumnWidth', value: 'WIDTH_3_12', touched: false }],
              }
            },
            {
              containerClasses: {
                phone: [{ property: 'ColumnWidth', value: 'WIDTH_12_12', touched: false }],
                tablet: [{ property: 'ColumnWidth', value: 'WIDTH_3_12', touched: false }],
                desktop: [{ property: 'ColumnWidth', value: 'WIDTH_3_12', touched: false }],
              }
            },
            {
              containerClasses: {
                phone: [{ property: 'ColumnWidth', value: 'WIDTH_12_12', touched: false }],
                tablet: [{ property: 'ColumnWidth', value: 'WIDTH_3_12', touched: false }],
                desktop: [{ property: 'ColumnWidth', value: 'WIDTH_3_12', touched: false }],
              }
            },
            {
              containerClasses: {
                phone: [{ property: 'ColumnWidth', value: 'WIDTH_12_12', touched: false }],
                tablet: [{ property: 'ColumnWidth', value: 'WIDTH_3_12', touched: false }],
                desktop: [{ property: 'ColumnWidth', value: 'WIDTH_3_12', touched: false }],
              }
            },
          ]
        }
      }
    }
  }
}
